/*
 *
 * Pickups actions
 *
 */

import * as constants from "./constants";

export function getPickups(query, rehydrating) {
  return {
    type: constants.PICKUPS_FETCH,
    query: query,
    rehydrating,
  };
}

export function hydratePickups() {
  return {
    type: constants.PICKUPS_OUTDATED,
  };
}
